import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { apiIntegration } from "../services/api-http";
import { replaceMessages } from "../store/conversation/actions";

export default function useMessageReconciliation(idConversa, messages) {
  const dispatch = useDispatch();
  const messagesRef = useRef(messages);
  const idConversaRef = useRef(idConversa);

  useEffect(() => {
    messagesRef.current = messages;
  }, [messages]);

  useEffect(() => {
    idConversaRef.current = idConversa;
  }, [idConversa]);

  useEffect(() => {
    if (process.env.REACT_APP_ENABLE_MESSAGE_RECONCILIATION !== 'true') return;
    
    if (!idConversaRef.current) return;

    let isChecking = false;

    const performSyncCheck = async () => {
      if (document.visibilityState !== "visible") return;
      

      const currentMessages = messagesRef.current;
      const currentId = idConversaRef.current;

      if (!currentId || !currentMessages || currentMessages.length === 0) return;
      
      if (isChecking) return;
      
      const localTotalCount = currentMessages.length;

      try {
        isChecking = true;
        
        const reconciliarResponse = await apiIntegration.post(
          `/webchat/conversations/${currentId}/reconciliar`,
          { 
            localTotalCount 
          }
        );

        const missingMessages = reconciliarResponse?.data?.messages || reconciliarResponse?.data?.data?.messages;
        if (missingMessages && Array.isArray(missingMessages) && missingMessages.length > 0) {
          dispatch(replaceMessages(missingMessages));
        }
      } catch (error) {
        console.error("Erro no sync-check/reconciliação:", error);
      } finally {
        isChecking = false;
      }
    };

    performSyncCheck();

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        performSyncCheck();
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [idConversa, dispatch]);
}
